import { api } from "./client";
import { getAppMarket } from "@/utils/market";
import type { Contact } from "./types"; // Убрал .ts расширение

import { toast } from "vue3-toastify";

export enum ShowMe {
    male = "male",
    female = "female",
    m_f = "m_f",
    m_m = "m_m",
    f_f = "f_f",
    everyone = "everyone"
}

export enum Pet {
    dog = "dog",
    cat = "cat",
    reptile = "reptile",
    amphibian = "amphibian",
    bird = "bird",
    fish = "fish",
    turtle = "turtle",
    rabbit = "rabbit",
    hamster = "hamster",
    i_want = "i_want",
    dont_have = "dont_have"
}

export enum ZodiacSign {
    aries = "aries",
    taurus = "taurus",
    gemini = "gemini",
    cancecr = "cancecr",
    leo = "leo",
    virgo = "virgo",
    libra = "libra",
    scorpius = "scorpius",
    sagittarius = "sagittarius",
    capricornus = "capricornus",
    aquarius = "aquarius",
    pisces = "pisces"
}

export enum Education {
    lower_secondary = "lower_secondary",
    secondary = "secondary",
    specialized_secondary = "specialized_secondary",
    incomplete_higher = "incomplete_higher",
    higher = "higher",
    two_or_more_higher = "two_or_more_higher",
    academic_degree = "academic_degree"
}

export enum Family {
    want_children = "want_children",
    dont_want_children = "dont_want_children",
    have_children_and_want = "have_children_and_want",
    have_children_and_dont_want = "have_children_and_dont_want",
    not_decided = "not_decided"
}

export enum Communication {
    texting = "texting",
    by_phone = "by_phone",
    videocall = "videocall",
    meet = "meet"
}

export enum LoveLanguage {
    gifts = "gifts",
    touches = "touches",
    compliments = "compliments",
    deeds = "deeds",
    constant_attention = "constant_attention"
}

export enum Alcohol {
    dont_drink = "dont_drink",
    on_holidays = "on_holidays",
    on_weekends = "on_weekends",
    drink_often = "drink_often"
}

export enum Smoking {
    for_the_company = "for_the_company",
    when_i_drink = "when_i_drink",
    i_smoke = "i_smoke",
    dont_smoke = "dont_smoke",
    give_up = "give_up"
}

export enum Sport {
    train_everyday = "train_everyday",
    train_often = "train_often",
    train_sometimes = "train_sometimes",
    dont_train = "dont_train"
}

export enum Food {
    veganism = "veganism",
    vegetarianism = "vegetarianism",
    pescatarianism = "pescatarianism",
    kosher_food = "kosher_food",
    everything = "everything"
}

export enum SocialNetwork {
    influencer = "influencer",
    active_user = "active_user",
    dont_use = "dont_use",
    sometimes_im_on = "sometimes_im_on"
}

export enum Sleep {
    lark = "lark",
    owl = "owl"
}

export enum Gender {
    male = "male",
    female = "female",
    m_f = "m_f",
    m_m = "m_m",
    f_f = "f_f"
}

export enum SexualOrientation {
    hetero = "hetero",
    gay = "gay",
    lesbian = "lesbian",
    bisexual = "bisexual",
    asexual = "asexual",
    not_decided = "not_decided"
}

export enum FamilyStatus {
    not_married = "not_married",
    married = "married",
    widow_er = "widow_er",
    divorced = "divorced"
}

export interface Interest {
    id?: number | string;
    key?: string;
    name: string;
    translation_ru?: string;
}

export interface ReferenceItem<T = string> {
    key: T;
    name: string;
}

export interface Club {
    id: number;
    name: string;
    image: string;
}

export interface ClubsData {
    my_clubs: Club[];
    additional: Club[];
}

export interface UpdateAccountInfoPayload {
    bio: string;
    interests: number[];
    show_me: ShowMe[];
    username: string | null;
    name: string;
    pets: Pet[];
    zodiac_sign: ZodiacSign;
    education: Education;
    family: Family;
    communication: Communication;
    love_language: LoveLanguage;
    alcohol: Alcohol;
    smoking: Smoking;
    sport: Sport;
    food: Food;
    social_network: SocialNetwork;
    sleep: Sleep;
    gender: Gender;
    sexual_orientation: SexualOrientation;
    show_my_orientation: boolean;
    residence: string;
    family_status: FamilyStatus;
    show_family_status: boolean;
    relationship_preference_id: number;
    educational_institution: string;
    show_my_age: boolean;
    show_distance_from_me: boolean;
}

export interface ReferenceData {
    interests: Interest[];
    relationshipPreferences: { id: number; preference: string };
    genders: Record<Gender, string>;
    zodiacSings: Record<ZodiacSign, string>;
    familyStatuses: ReferenceItem<FamilyStatus>[];
    education: Record<Education, string>;
    family: Record<Family, string>;
    communication: Record<Communication, string>;
    loveLanguages: Record<LoveLanguage, string>;
    pets: Record<Pet, string>;
    alcohol: Record<Alcohol, string>;
    smoking: Record<Smoking, string>;
    sport: Record<Sport, string>;
    food: Record<Food, string>;
    socialNetwork: Record<SocialNetwork, string>;
    sleep: Record<Sleep, string>;
    orientations: Record<SexualOrientation, string>;
    clubs: ClubsData | null;
}


function un(res: any) {
    return res?.data?.data ?? res?.data ?? res;
}

export async function getProfileById(idProfile: string) {
    const res = await api.get(`/users/info/${idProfile}`);
    return un(res);
}

export async function getMyProfile() {
    const token = localStorage.getItem("access_token");
    if (!token) {
        console.log("[getMyProfile] no token — skip request");
        return null;
    }

    try {
        const res = await api.get("/users/profile");
        return un(res);
    } catch (e: any) {
        if (e?.response?.status === 401) {
            console.log("[getMyProfile] unauthorized — skipping");
            return null;
        }
        console.warn("[getMyProfile] fail:", e);
        return null;
    }
}

export async function updateMyProfileSettigsPlus(payload: any) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        console.log("[updateMyProfile] no token — skip request");
        return null;
    }

    try {
        const res = await api.put("/users/settings/plus", payload);
        return un(res);
    } catch (e: any) {
        const status = e?.response?.status;
        const data = e?.response?.data;

        if (status === 401) {
            console.warn("[updateMyProfile] Unauthorized");
            throw new Error("Не авторизован. Пожалуйста, войдите в систему снова.");
        }

        if (status === 406 && data?.errors) {
            console.warn("Not acceptable - subscription required");
            throw new Error("Not acceptable - subscription required");
        }

        if (status === 422 && data?.errors) {
            console.warn("NValidation error");
            throw new Error("Validation error");
        }

        if (status === 500) {
            console.error("[updateMyProfile] Server error:", data);
            throw new Error("Ошибка на сервере. Попробуйте позже.");
        }

        console.warn("[updateMyProfile] fail:", e);
        throw new Error("Не удалось обновить профиль.");
    }
}

export async function updateMyProfile(payload: any) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        console.log("[updateMyProfile] no token — skip request");
        return null;
    }

    try {
        const res = await api.put("/users/profile", payload);
        return un(res);
    } catch (e: any) {
        const status = e?.response?.status;
        const data = e?.response?.data;

        if (status === 401) {
            console.warn("[updateMyProfile] Unauthorized");
            throw new Error("Не авторизован. Пожалуйста, войдите в систему снова.");
        }

        if (status === 422 && data?.errors) {
            const messages: string[] = [];

            for (const [field, errors] of Object.entries(data.errors)) {
                if (Array.isArray(errors)) messages.push(...errors);
            }

            throw new Error(messages.join("\n"));
        }

        if (status === 500) {
            console.error("[updateMyProfile] Server error:", data);
            throw new Error("Ошибка на сервере. Попробуйте позже.");
        }

        console.warn("[updateMyProfile] fail:", e);
        throw new Error("Не удалось обновить профиль.");
    }
}

export async function updateUserCity(formatted_address: string | null) {
    const res = await api.post("/users/city", { formatted_address });
    return un(res);
}


export async function getLikes(filter?: string) {
    const res = await api.get("/users/likes", {
        params: filter ? { filter } : {},
    });
    return un(res);
}

export async function deleteLike(id: string) {
    const res = await api.delete(`/users/likes/${id}`);
    return un(res);
}

export async function VerifyAccount(payload: FormData) {
    const res = await api.post("/user/verification-request", payload, {
        headers: {}
    });
    return res.data;
}

export async function getPackages() {
    const res = await api.get("/users/packagesInfo");
    return un(res);
}

export async function Superboom() {
    const res = await api.post(
        "recommendations/superboom"
    );
    return un(res);
}

export async function Superlike(user_id: string, from_top: boolean = false, comment?: string) {
    const payload = {
        user_id,
        from_top,
        comment
    };

    const res = await api.post(
        "/recommendations/superlike",
        payload
    );

    return un(res);
}

export async function removePushToken(token: string) {
    try {
        const res = await api.delete("/users/settings/token", {
            data: { token },
        });
        console.log("[removePushToken] удалён:", res.data);
        return res.data;
    } catch (e: any) {
        console.error("[removePushToken] ошибка:", e?.response?.data || e);
        throw e;
    }
}

export async function AddAccountContacts(payload: Partial<Contact>) {
    const res = await api.post("/users/contacts-information", payload);
    return {
        data: un(res),
        meta: res.data?.meta || {}
    };
}

export async function UpdateAccountContacts(payload: Partial<Contact>) {
    const res = await api.put("/users/contacts-information", payload);
    return {
        data: un(res),
        meta: res.data?.meta || {}
    };
}

export async function GetAccountContacts(): Promise<Partial<Contact>> {
    const res = await api.get("/users/contacts-information");
    return (un(res) || {}) as Partial<Contact>;
}

export async function sendDeviceToken(token: string) {
    console.log("[debug] sendDeviceToken() вызван с:", token);

    const market = getAppMarket();

    const ua = navigator.userAgent;
    const platform = navigator.platform || "unknown";

    const osName = (() => {
        if (/windows/i.test(ua)) return "Windows";
        if (/mac/i.test(ua)) return "MacOS";
        if (/android/i.test(ua)) return "Android";
        if (/linux/i.test(ua)) return "Linux";
        if (/iphone|ipad|ios/i.test(ua)) return "iOS";
        return "Unknown";
    })();

    const payload = {
        token,
        application: `version: 1.0, market: ${market}`,
        device: `os name: ${osName}, os version: ${navigator.appVersion || "unknown"}, brand: ${platform}, hasGms: false, hasHms: false`,
    };

    try {
        console.log("[debug] POST /users/settings/token:", payload);
        const res = await api.post("/users/settings/token", payload);
        console.log("[sendDeviceToken] ✅ отправлено:", payload);
        return res.data;
    } catch (e: any) { 
        console.error("[sendDeviceToken] ❌ ошибка:", e?.response?.data || e);
    }
}

async function fetchReference<T = string>(url: string): Promise<ReferenceItem<T>[]> {
    try {
        const resp = await api.get(url);
        const items = resp.data.items ?? {};

        return Object.entries(items).map(([key, name]) => ({
            key: key as T,
            name: name as string,
        }));
    } catch (e: any) { 
        console.error(`[fetchReference] ${url}`, e);
        return [];
    }
}

function normalizeItems(data: Record<string, string> | null): ReferenceItem<string>[] {
    if (!data) return [];
    return Object.entries(data).map(([key, name]) => ({ key, name }));
}

export async function getReferenceData(gender: Gender): Promise<ReferenceData | null> {
    try {
        const [
            interestsRes,
            relationshipPreferencesRes,
            gendersRes,
            zodiacSingsRes,
            familyStatusesRes,
            educationRes,
            familyRes,
            communicationRes,
            loveLanguagesRes,
            petsRes,
            alcoholRes,
            smokingRes,
            sportRes,
            foodRes,
            socialNetworkRes,
            sleepRes,
            orientationsRes,
            clubsRes
        ] = await Promise.all([
            api.get("/users/reference-data/interests"),
            api.get("/users/reference-data/relationship-preferences"),
            api.get("/users/reference-data/genders"),
            api.get("/users/reference-data/zodiac-signs"),
            api.get("/users/reference-data/family-statuses", { params: { gender }, }),
            api.get("/users/reference-data/education"),
            api.get("/users/reference-data/family"),
            api.get("/users/reference-data/communication"),
            api.get("/users/reference-data/love-languages"),
            api.get("/users/reference-data/pets"),
            api.get("/users/reference-data/alcohol"),
            api.get("/users/reference-data/smoking"),
            api.get("/users/reference-data/sport"),
            api.get("/users/reference-data/food"),
            api.get("/users/reference-data/social-network"),
            api.get("/users/reference-data/sleep"),
            api.get("/users/reference-data/orientations"),
            api.get("/users/reference-data/clubs")
        ]);

        return {
            interests: interestsRes.data.data.items ?? {},
            relationshipPreferences: relationshipPreferencesRes.data.data.items ?? {},
            genders: gendersRes.data.data.items ?? {},
            zodiacSings: zodiacSingsRes.data.data.items ?? {},
            familyStatuses: familyStatusesRes.data.data.items ?? {},
            education: educationRes.data.data.items ?? {},
            family: familyRes.data.data.items ?? {},
            communication: communicationRes.data.data.items ?? {},
            loveLanguages: loveLanguagesRes.data.data.items ?? {},
            pets: petsRes.data.data.items ?? {},
            alcohol: alcoholRes.data.data.items ?? {},
            smoking: smokingRes.data.data.items ?? {},
            sport: sportRes.data.data.items ?? {},
            food: foodRes.data.data.items ?? {},
            socialNetwork: socialNetworkRes.data.data.items ?? {},
            sleep: sleepRes.data.data.items ?? {},
            orientations: orientationsRes.data.data.items ?? {},
            clubs: clubsRes.data.data ?? [],
        };
    } catch (e: any) { // Добавил тип any
        console.error("[getReferenceData]", e);
        return null;
    }
}


export async function searchInterests(search: string): Promise<Interest[]> {
    try {
        const res = await api.get("/users/reference-data/interests", {
            params: { search },
        });
        return res.data?.items ?? [];
    } catch (e: any) { // Добавил тип any
        console.error("[searchInterests]", e);
        return [];
    }
}

export async function fetchCities() {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const resp = await api.get("/users/settings/cities", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        console.log(resp.data, 'data');
        return resp.data;

    } catch (err: any) { // Добавил тип any
        console.error("Ошибка загрузки городов:", err);

        const errorMessage = err.response?.data?.message || "Не удалось загрузить города";
        toast.error(errorMessage);
        throw err;
    }
}

export async function savePhoto(formData: FormData) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const response = await api.post('/users/photos', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data, "uploaded photo");
        return response.data;

    } catch (err: any) {
        console.error("Ошибка загрузки фото:", err);

        const errorMessage = err.response?.data?.message || "Не удалось загрузить фото";
        toast.error(errorMessage);

        throw err;
    }
}

export async function replacePhoto(photoId: number | string, photo: File) {
    const token = localStorage.getItem("access_token");
    if (!token) throw new Error("Требуется авторизация");

    const formData = new FormData();
    formData.append("photo_id", String(photoId));
    formData.append("photo", photo);

    try {
        const response = await api.post("/users/photos/replace", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (err: any) {
        console.error("[ProfileEditor] photo replacement failed", err.response?.data || err);
        const errorMessage = err.response?.data?.message || "Не удалось заменить фотографию";
        toast.error(errorMessage);
        throw err;
    }
}

/**
 * Применяет загрузку, удаление и порядок фотографий одной атомарной операцией.
 * Backend должен валидировать итоговое количество фотографий до внесения изменений.
 */
export async function savePhotoChanges(formData: FormData) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const response = await api.post("/users/photos", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (err: any) {
        console.error("Ошибка сохранения набора фотографий:", err);
        const errorMessage =
            err.response?.data?.message ||
            "Не удалось сохранить фотографии. Изменения не применены";
        toast.error(errorMessage);
        throw err;
    }
}

export async function getPhoto() {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const response = await api.get('/users/photos', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        console.log(response.data, "loaded photos");
        return response.data.data.photos;

    } catch (err: any) {
        console.error("Ошибка загрузки фото:", err);

        const errorMessage = err.response?.data?.message || "Не удалось загрузить фото";
        toast.error(errorMessage);

        throw err;
    }
}

export async function removePhoto(photoId: string) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const response = await api.delete(`/users/photos`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            data: {
                fid: photoId
            }
        });

        console.log(response.data, "deleted photo");
        return response.data;

    } catch (err: any) {
        console.error("Ошибка удаления фото:", err);

        const errorMessage = err.response?.data?.message || "Не удалось удалить фото";
        toast.error(errorMessage);

        throw err;
    }
}

export async function setMainPhoto(fid: string) {
    const token = localStorage.getItem("access_token");
    if (!token) {
        toast.error("Требуется авторизация");
        throw new Error("Требуется авторизация");
    }

    try {
        const response = await api.patch(
            '/users/photos/main',
            { fid },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;

    } catch (err: any) {
        console.error("Ошибка установки главного фото:", err);
        const errorMessage = err.response?.data?.message || "Не удалось установить главное фото";
        toast.error(errorMessage);
        throw err;
    }
}

// Добавляем отсутствующий метод addDeviceToken
export async function addDeviceToken(token: string) {
    return sendDeviceToken(token);
}

export async function getVerificationStatus() {
    const res = await api.get("/users/verification-status");
    return res.data?.data;
}

export async function getLikesInfo() {
    const res = await api.get("/recommendations/likes/info");
    return un(res);
}

export async function postPerformLike(userId: string, fromTop: boolean = true) {
    const res =  await api.post('/recommendations/v2/like', {
        user_id: userId,
        from_top: fromTop,
    });
    return un(res);
}

export async function postFeedback(feedback: string, userId: string ) {
    const res =  await api.post('/users/feedbacks', {
        feedback: feedback,
        user_id: userId,
    });
    return un(res);
}

export async function postComplaint( userId: string, type: string ) {
    const res =  await api.post('/users/complaints', {
        user_id: userId,
        type: type
    });
    return un(res);
}
